import {
    DotsHorizontalIcon,
} from '@radix-ui/react-icons';
import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useContext, useEffect, useState, } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { AuthContext } from '../../context/AuthContext';
import api from '../../lib/api';
import ApproveBunnyDialog from '../dialogs/approveBunnyDialog';
import DenyBunnyDialog from '../dialogs/denyBunnyDialog';
import { Button } from '../ui/button';
import {
    Dialog,
} from "../ui/dialog";
import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "../ui/dropdown-menu";
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = (fetchBunnies) => [
    {
        accessorKey: "full_name",
        header: ({ column }) => <DatatableSortButton column={column}>Namn</DatatableSortButton>,
        cell: info => {
            const bunny = info.row.original;
            return <Link to={`/bunny/${bunny.id}`} className='text-blue-600 font-medium hover:underline'>{bunny.full_name}</Link>
        }
    },
    {
        accessorKey: "gender",
        header: ({ column }) => <DatatableSortButton column={column}>Kön</DatatableSortButton>,
        cell: info => {
            const bunny = info.row.original;
            if (bunny.gender === "male") return "Hane";
            if (bunny.gender === "female") return "Hona";
            return bunny.gender; // fallback in case there are other values
        }
    },
    {
        id: "actions",
        enableHiding: false,
        cell: ({ row }) => {
            const bunny = row.original;
            return (
                <Dialog modal={true} >
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" className="h-8 w-8 p-0 float-right">
                                <span className="sr-only">Öppna meny</span>
                                <DotsHorizontalIcon className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" onCloseAutoFocus={(e) => {
                            e.preventDefault();
                        }}>
                            <DropdownMenuLabel>Alternativ</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            <ApproveBunnyDialog bunny={bunny} fetchBunnies={fetchBunnies} />
                            <DenyBunnyDialog bunny={bunny} fetchBunnies={fetchBunnies} />
                        </DropdownMenuContent>
                    </DropdownMenu>
                </Dialog>
            );
        }
    },
];

export function ApproveBunnyDatatable({ userId }) {
    const [sorting, setSorting] = useState([{ id: 'full_name', desc: false }]);
    const [bunnies, setBunnies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [columnFilters, setColumnFilters] = useState([]);
    const [filterInput, setFilterInput] = useState("");
    const { auth } = useContext(AuthContext);

    const fetchBunnies = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/non-approved`);
            const bunnies = response.data.map(bunny => ({
                ...bunny,
            }));
            setBunnies(bunnies);
        } catch (error) {
            console.error('Error fetching bunnies:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBunnies();
    }, [userId]);

    // Delay function before filtering to reduce bounce
    useEffect(() => {
        const handler = setTimeout(() => {
            table.getColumn("full_name")?.setFilterValue(filterInput);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filterInput]);

    const table = useReactTable({
        data: bunnies,
        columns: columns(fetchBunnies, auth),
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <>
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 py-3'>
                <div className='grid gap-3'>
                    <div className='flex flex-col gap-2'>
                        <Label htmlFor='searchBunny'>Kanin</Label>
                        <Input
                            id='searchBunny'
                            placeholder="Sök kanin..."
                            value={filterInput}
                            disabled={isLoading}
                            onChange={event => setFilterInput(event.target.value)}
                            autoComplete='off'
                        />
                    </div>
                </div>
            </div>
            <DataTable
                table={table}
                isLoading={isLoading}
                columns={columns(fetchBunnies, auth)}
                skeletonRows={3}
            />
        </>
    );
}
